import { LayerDetailsReport } from '@app/components/Molecules/RiskSideDrawerContent/data_fetchers/layerDetailsFetcher'
import type { LayerMetadata } from '@app/types/layerTypes'

const getDetailValue = (layerDetail: LayerDetailsReport | null, label: string) =>
  layerDetail?.details?.find((detail) => detail.label === label)?.value ?? null

/**
 * Builds a LayerMetadata-shaped object from the read-only catalog record (LayerDetailsReport)
 * for layers that don't have admin-managed metadata yet.
 */
export const buildLayerMetadataFromDetail = (
  layerDetail: LayerDetailsReport | null,
  defaultTitle?: string,
): Partial<LayerMetadata> => {
  const licenseTitle = getDetailValue(layerDetail, 'License')

  return {
    title: layerDetail?.sections?.[0]?.title ?? defaultTitle ?? '',
    description_md: layerDetail?.sections?.[0]?.description ?? null,
    provider: getDetailValue(layerDetail, 'Provider'),
    spatial_extent: null,
    created_at: getDetailValue(layerDetail, 'Date added'),
    owner_name: null,
    owner_organization: null,
    owner_email: null,
    confidence_rating: null,
    limitations_caveats_md: null,
    source_links: layerDetail?.sources ?? [],
    license: licenseTitle ? { title: licenseTitle } : null,
    additional_notes_md: layerDetail?.additional_information?.length
      ? layerDetail.additional_information
          .map((info) => `- [${info.title}](${info.url})`)
          .join('\n')
      : null,
  }
}
